import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLongitude = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.99968 1.33301C6.68114 1.33301 5.3922 1.724 4.29588 2.45654C3.19955 3.18909 2.34506 4.23028 1.84048 5.44845C1.3359 6.66663 1.20387 8.00707 1.46111 9.30028C1.71834 10.5935 2.35328 11.7814 3.28563 12.7137C4.21798 13.6461 5.40587 14.281 6.69908 14.5382C7.99228 14.7955 9.33273 14.6635 10.5509 14.1589C11.7691 13.6543 12.8103 12.7998 13.5428 11.7035C14.2754 10.6071 14.6663 9.31822 14.6663 7.99967C14.6611 6.23319 13.957 4.54056 12.7079 3.29146C11.4588 2.04236 9.76616 1.33828 7.99968 1.33301ZM6.26634 13.0663C5.21522 12.6993 4.30427 12.0144 3.6597 11.1066C3.01513 10.1988 2.66886 9.11304 2.66886 7.99967C2.66886 6.88631 3.01513 5.80051 3.6597 4.89271C4.30427 3.9849 5.21522 3.30004 6.26634 2.93301C5.44227 4.49525 5.00773 6.23342 4.99968 7.99967C5.00773 9.76592 5.44227 11.5041 6.26634 13.0663ZM7.99968 13.333C6.90463 11.771 6.3222 9.90725 6.33301 7.99967C6.3222 6.0921 6.90463 4.22834 7.99968 2.66634C9.09473 4.22834 9.67715 6.0921 9.66634 7.99967C9.67715 9.90725 9.09473 11.771 7.99968 13.333ZM9.73301 13.0663C10.5647 11.507 10.9997 9.76692 10.9997 7.99967C10.9997 6.23242 10.5647 4.49235 9.73301 2.93301C10.7857 3.29791 11.6983 3.98216 12.3436 4.89038C12.9889 5.79861 13.3348 6.88554 13.333 7.99967C13.348 9.11687 13.0072 10.2099 12.3601 11.1207C11.713 12.0315 10.7929 12.7129 9.73301 13.0663Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLongitude);
export default ForwardRef;
